import { Checkbox } from "@/components/ui/checkbox";

const PRICED = { FR: "France", CH: "Suisse", GB: "Royaume-Uni", IE: "Irlande", BE: "Belgique", NL: "Pays-Bas", PT: "Portugal", LU: "Luxembourg", ES: "Espagne", IT: "Italie", DE: "Allemagne", AT: "Autriche", CZ: "Tchéquie", SI: "Slovénie", PL: "Pologne", SE: "Suède", AU: "Australie", NC: "Nouvelle-Calédonie" };

export const ExtraPriceCountries = ({ value = [], onChange, sectorCountries = [] }) => {
  const toggle = (c, on) => onChange(on ? [...value, c] : value.filter((x) => x !== c));
  return (
    <div className="col-span-2 rounded-md border p-3" data-testid="reseller-extra-price-countries">
      <div className="text-sm font-medium">Tarifs d'autres pays (vendeur frontalier)</div>
      <p className="text-xs text-muted-foreground mb-2">Donne accès aux prix de ces pays en plus de ceux de ses secteurs, sans changer sa zone de vente.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5">
        {Object.entries(PRICED).map(([c, label]) => {
          const own = sectorCountries.includes(c);
          return (
            <label key={c} className={`flex items-center gap-2 text-sm ${own ? "opacity-60" : "cursor-pointer"}`} data-testid={`extra-price-${c}`}>
              <Checkbox checked={own || value.includes(c)} disabled={own} onCheckedChange={(v) => toggle(c, !!v)} data-testid={`extra-price-check-${c}`} />
              {label}{own && <span className="text-[10px] text-muted-foreground">(secteur)</span>}
            </label>
          );
        })}
      </div>
    </div>
  );
};
